import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AddressBookRecord } from '@tassat/fred-definitions';
import React from 'react';

interface WalletNameCellRendererProps {
    data: AddressBookRecord;
}

const muiStyles = makeStyles({
    root: {
        height: '100%',
        whiteSpace: 'normal'
    },
    text: { lineHeight: '24px' }
});

const AddressBookWalletNameCellRenderer = (props: WalletNameCellRendererProps) => {
    const { data } = props;

    const classes = muiStyles(props);
    const name = data.NickName ? data.NickName : data.AccountName;

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            <span className={classes.text}>{name}</span>
        </Grid>
    );
};

export default AddressBookWalletNameCellRenderer;